export default {
  noBookmarks: {
    id: 'settings.bookmarks.noBookmarks',
    defaultMessage: 'You have no bookmarks. Save items by pressing the bookmark icon under a post.',
  },
};
